module.exports = __webpack_public_path__ + "static/media/wenan.34ec5db0.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/wenan.png
// module id = 250
// module chunks = 0